import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-show-new-badge',
    templateUrl: './show-new-badge.component.html',
    styleUrls: ['./show-new-badge.component.scss'],
    standalone: false
})
export class ShowNewBadgeComponent {

  @Input() showBadge: boolean;

}
